<template>
  <v-data-table :headers="headers" :items="extensions" item-key="extensionNo" style="width: 100%;">
    <template v-slot:items="props">
      <tr>
        <td>
          <v-text-field
            v-model="extensions[props.index].extensionNo"
            label="Edit"
            single-line
            @change="settoEdited(extensions[props.index])"
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            v-model="extensions[props.index].extensionName"
            label="Edit"
            single-line
            @change="settoEdited(extensions[props.index])"
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            v-model="extensions[props.index].macAddress"
            label="Edit"
            single-line
            @change="settoEdited(extensions[props.index])"
          ></v-text-field>
        </td>
        <td>
          <v-layout row>
            <v-text-field
              v-model="extensions[props.index].grenkeFinanceNo"
              label="Edit"
              single-line
              @change="settoEdited(extensions[props.index])"
            ></v-text-field>
            <v-btn
              v-if="props.index==0"
              color="primary"
              small
              round
              @click="copyDown('grenkeFinanceNo')"
              title="copy down"
            >Copy Down</v-btn>
          </v-layout>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: "AdminSubtable",
  props: {
    extensions: { type: Array, required: true }
    // errors: { type: Array, required: true }
  },
  data() {
    return {
      headers: [
        {
          text: "Extension #",
          align: "left",
          sortable: false,
          value: "extensionNo"
        },
        {
          text: "Extension Name",
          align: "left",
          sortable: true,
          value: "extensionName"
        },
        {
          text: "Mac Address",
          align: "left",
          sortable: false,
          value: "macAddress"
        },
        { text: "Grenke Order #", value: "grenkeFinanceNo" }
      ]
    };
  },
  methods: {
    settoEdited(item) {
      this.$emit("settoEdited", item);
    },
    copyDown: function(column) {
      let vm = this;
      for (var i = 1; i < vm.extensions.length; i++) {
        vm.extensions[i][column] = vm.extensions[0][column];
      }
      return;
    }
  }
};
</script>